export interface IUnifiedClassSkills {
  skillId: number;
  skillName: string;
  assessment: string | null;
  displayOrder: number | null;
  classSkillAssignId: number | null | undefined;
  active: boolean;
}

export class UnifiedClassSkills implements IUnifiedClassSkills {
  skillId;
  skillName;
  assessment;
  displayOrder;
  classSkillAssignId;
  active;

  constructor(config: IUnifiedClassSkills) {
    this.skillId = config.skillId;
    this.skillName = config.skillName;
    this.assessment = config.assessment;
    this.displayOrder = config.displayOrder;
    this.classSkillAssignId = config.classSkillAssignId;
    this.active = config.active;
  }
}
